<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import UserProfile from "@/router/views/users/user-profile"

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import UserUtils from '@/helpers/users';
import FinanceUtils from '@/helpers/finance';
import Storage from "@/helpers/storage"

// Services
import FinanceDataService from "@/services/FinanceDataService";
import MarketingDataService from "@/services/MarketingDataService"
import UsersDataService from "@/services/UsersDataService"

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

// Lib
import isEmpty from "is-empty";

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  name: "subscriptions",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Finance Subscriptions",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },
  methods: {
    ...UserUtils,
    ...DateUtils,
    ...FinanceUtils,

    handlePageChange(value) {
      this.page = value;
      if (this.subscriptionsSearch === 'filters')
        this.loadSubscriptions();
      else if (this.subscriptionsSearch === 'search')
        this.processSearch(false);
    },

    handlePageExtendedChange(value) {
      this.pageExtended = value;
      this.loadExtendedStats(true);
    },

    handleDisplayChange() {
      this.loadSubscriptions();
    },

    handleDisplayExtendedChange() {
      this.loadExtendedStats(true);
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.toDate = this.filters.fromDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    handleDateExtendedChange() {
      let now = new this.$moment();
      switch(this.filtersSubscriptionsExtended.dates.selected) {
        case "always":
          this.filtersSubscriptionsExtended.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.toDate = now.format('YYYY-MM-DD');
          break;
        case "week":
          this.filtersSubscriptionsExtended.toDate = now.format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersSubscriptionsExtended.toDate = now.format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersSubscriptionsExtended.toDate = now.format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersSubscriptionsExtended.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersSubscriptionsExtended.toDate = now.format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersSubscriptionsExtended.toDate = now.format('YYYY-MM-DD');
          this.filtersSubscriptionsExtended.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersSubscriptionsExtended.fromDate = null;
          this.filtersSubscriptionsExtended.toDate = null;
          break;
      }
    },

    handleDatePerformanceChange() {
      let now = new this.$moment();
      switch(this.filtersPerformance.dates.selected) {
        case "always":
          this.filtersPerformance.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersPerformance.fromDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersPerformance.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersPerformance.toDate = this.filtersPerformance.fromDate;
          break;
        case "week":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersPerformance.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersPerformance.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersPerformance.fromDate = null;
          this.filtersPerformance.toDate = null;
          break;
      }
    },

    handleDateSubscriptionsHistoryChange() {
      this.loadSubscriptionsHistory();
    },

    getRequestParams() {
      const params = {};

      params["page"] = this.page - 1;
      params["size"] = this.pageSizes.selected;

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['gender'] = this.filters.genders.selected;
      params['subscription'] = this.filters.subscriptions.selected;
      params['offer'] = this.filters.promo.selected;
      params['paymentMethod'] = this.filters.paymentMethod.selected;
      params['paymentProcessor'] = this.filters.paymentProcessor.selected;
      params['organic'] = this.filters.organic.selected;
      params['countries'] = this.filters.countries.selected;
      if (this.filters.adsData3.selected !== 'all') {
        params['ads'] = this.filters.adsData3.selected;
      }
      else if (this.filters.adsData2.selected !== 'all') {
        params['ads'] = this.filters.adsData2.selected;
      }
      else if (this.filters.adsData1.selected !== 'all') {
        params['ads'] = this.filters.adsData1.selected;
      }
      else {
        params['ads'] = this.filters.ads.selected;
      }

      if (!isEmpty(this.filters.userId)) {
        params['userId'] = this.filters.userId;
      }

      params['status'] = this.filters.status.selected;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsExtended(onlyListing) {
      const params = {};

      if (this.filtersSubscriptionsExtended.dates.selected === 'custom' && this.filtersSubscriptionsExtended.dates.dateRange !== null) {
        this.filtersSubscriptionsExtended.fromDate = this.$moment(this.filtersSubscriptionsExtended.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersSubscriptionsExtended.toDate = this.$moment(this.filtersSubscriptionsExtended.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersSubscriptionsExtended.fromDate === null)
        this.handleDateExtendedChange();

      if (this.filtersSubscriptionsExtended.toDate !== null)
        params['toDate'] = this.filtersSubscriptionsExtended.toDate;

      if (this.filtersSubscriptionsExtended.fromDate !== null)
        params['fromDate'] = this.filtersSubscriptionsExtended.fromDate;

      params['gender'] = this.filtersSubscriptionsExtended.genders.selected;
      params['countries'] = this.filtersSubscriptionsExtended.countries.selected;
      params['onlyListing'] = onlyListing;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsPerformance() {
      const params = {};

      if (this.filtersPerformance.dates.selected === 'custom' && this.filtersPerformance.dates.dateRange !== null) {
        this.filtersPerformance.fromDate = this.$moment(this.filtersPerformance.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersPerformance.toDate = this.$moment(this.filtersPerformance.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersPerformance.fromDate === null)
        this.handleDatePerformanceChange();

      if (this.filtersPerformance.toDate !== null)
        params['toDate'] = this.filtersPerformance.toDate;

      if (this.filtersPerformance.fromDate !== null)
        params['fromDate'] = this.filtersPerformance.fromDate;

      params['gender'] = this.filtersPerformance.genders.selected;
      params['offer'] = this.filtersPerformance.promo.selected;
      params['subscription'] = this.filtersPerformance.subscriptions.selected;
      params['paymentMethod'] = this.filtersPerformance.paymentMethod.selected;
      params['paymentProcessor'] = this.filtersPerformance.paymentProcessor.selected;
      params['countries'] = this.filtersPerformance.countries.selected;
      params['organic'] = this.filtersPerformance.organic.selected;
      if (this.filtersPerformance.adsData3.selected !== 'all') {
        params['ads'] = this.filtersPerformance.adsData3.selected;
      }
      else if (this.filtersPerformance.adsData2.selected !== 'all') {
        params['ads'] = this.filtersPerformance.adsData2.selected;
      }
      else if (this.filtersPerformance.adsData1.selected !== 'all') {
        params['ads'] = this.filtersPerformance.adsData1.selected;
      }
      else {
        params['ads'] = this.filtersPerformance.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getFilters() {
      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            marketing.ads = response.data.filters.ads;
            response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
              this.filtersPerformance.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });
    },

    getAdsFiltersData1(filters, value) {
      filters.adsData1.selected = 'all';
      filters.adsData2.selected = 'all';
      filters.adsData3.selected = 'all';
      filters.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[value])) {
        MarketingDataService.getAdsNonOrganicData1Filters(value)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                filters.adsData1.options.push(ad);
              });

              ads[value] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[value].forEach(ad => {
          filters.adsData1.options.push(ad);
        });
      }
    },

    getAdsFiltersData2(filters, value) {
      filters.adsData2.selected = 'all';
      filters.adsData3.selected = 'all';
      filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[value])) {
        MarketingDataService.getAdsNonOrganicData2Filters(value)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                filters.adsData2.options.push(ad);
              });

              adsData1[value] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[value].forEach(ad => {
          filters.adsData2.options.push(ad);
        });
      }
    },

    getAdsFiltersData3(filters, value) {
      filters.adsData3.selected = 'all';
      filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[value])) {
        MarketingDataService.getAdsNonOrganicData3Filters(value)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                filters.adsData3.options.push(ad);
              });

              adsData2[value] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[value].forEach(ad => {
          filters.adsData3.options.push(ad);
        });
      }
    },

    loadSubscriptionsHistory() {
      const params = {
        date: this.filtersSubscriptionsHistoryDates.selected,
        country: this.filtersSubscriptionsHistoryCountries.selected
      };
      FinanceDataService.getSubscriptionsHistory(params)
          .then(response => {
            const {data} = response.data;
            this.stats.total_active = data.total_active;
            this.stats.total_subs = data.total_subs;
            this.stats.total_canceled = data.total_canceled;
            this.stats.total_suspended = data.total_suspended;

            this.$refs.subscriptionsTotalHistoryChart.updateSeries([
              {
                name: 'Total',
                type: 'line',
                data: data.total
              },
              {
                name: 'Active + Suspended',
                type: 'line',
                data: data.possible
              }
            ]);

            this.$refs.subscriptionsHistoryChart.updateSeries([
                {
                name: "Active",
                type: 'area',
                data: data.active
              },{
                name: 'Suspended',
                data: data.suspended,
                type: 'line'
              },{
                name: 'Canceled',
                type: 'line',
                data: data.canceled
              }
            ]);
          })
          .catch(error => {
            window.console.error("FinanceDataService.getSubscriptionsHistory failed...", error);
          });
    },

    loadStats() {
      const params = this.getRequestParams();
      FinanceDataService
          .getSubscriptionsStats(params)
          .then(response => {
            const {stats, products, processors, evolGraph} = response.data;
            this.stats.active = stats.active;
            this.stats.active_perc = stats.active_perc;
            this.stats.suspended = stats.suspended;
            this.stats.suspended_perc = stats.suspended_perc;
            this.stats.canceled = stats.canceled;
            this.stats.canceled_perc = stats.canceled_perc;
            this.stats.ended = stats.ended;
            this.stats.ended_perc = stats.ended_perc;

            this.productsGraph.series = products.series;
            this.productsGraph.chartOptions = {...this.productsGraph.chartOptions, ...{
                labels: products.labels
              }};

            /*this.methodsGraph.series = methods.series;
            this.methodsGraph.chartOptions = {...this.methodsGraph.chartOptions, ...{
                labels: methods.labels
              }};*/

            this.processorsGraph.series = processors.series;
            this.processorsGraph.chartOptions = {...this.processorsGraph.chartOptions, ...{
                labels: processors.labels
              }};

            this.$refs.subscriptionsEvolChart.updateSeries([{
              name: "New",
              type: 'bar',
              data: evolGraph.active
            },{
              name: "Suspended",
              type: 'bar',
              data: evolGraph.suspended
            }, {
              name: "Canceled",
              type: 'bar',
              data: evolGraph.canceled
            }, {
              name: "Ended",
              type: 'bar',
              data: evolGraph.ended
            }]);

          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadExtendedStats(onlyListing) {
      this.isLoadingExtended = true;
      const params = this.getRequestParamsExtended(onlyListing);
      FinanceDataService
          .getSubscriptionsExtendedStats(params)
          .then(response => {
            const {stats, historyGraph} = response.data;
            if (!onlyListing) {
              this.stats.extended = stats.extended;
              this.stats.extendedRenew = stats.renew;
              this.stats.extendedCanceled = stats.canceled;
              this.stats.extendedExcluded = stats.excluded;
              this.stats.extendedDisplayed = stats.displayed;
              this.stats.extendedDeclined = stats.declined;
              this.stats.extendedAccepted = stats.accepted;

              this.$refs.extendedGraphChart.updateSeries([{
                name: "Not Extended",
                data: historyGraph.excluded
              }, {
                name: "Extended",
                data: historyGraph.extended
              }]);

              this.$refs.extendedStatsGraphChart.updateSeries([{
                name: "Has Renew",
                data: historyGraph.renew
              }, {
                name: "Canceled",
                data: historyGraph.canceled
              }]);

              this.$refs.extendedPurposeGraphChart.updateSeries([{
                name: "Displayed",
                data: historyGraph.displayed
              }, {
                name: "Declined",
                data: historyGraph.declined
              }]);
            }

            const { items, totalItems } = response.data.listing;
            this.subscriptionsExtended = items;
            this.countExtended = totalItems;
            this.getMediaThumbExtended();

          })
          .catch(error => {
            window.console.error(error);
          })
          .finally(() => {
            this.isLoadingExtended = false;
          });
    },

    loadPerformance() {
      this.isLoadingPerformance = true;
      const params = this.getRequestParamsPerformance();
      FinanceDataService
          .getSubscriptionsPerformance(params)
          .then(response => {
            const {stats, ageGraph, evolCancelGraph} = response.data;
            this.stats.perf_first = stats.perf_first;
            this.stats.perf_canceled_48d = stats.perf_canceled_48d;
            this.stats.perf_canceled = stats.perf_canceled;
            this.stats.perf_canceled_1w = stats.perf_canceled_1w;
            this.stats.perf_renew_1 = stats.perf_renew_1;
            this.stats.perf_renew_2 = stats.perf_renew_2;
            this.stats.perf_renew_3 = stats.perf_renew_3;
            this.stats.perf_renew_4 = stats.perf_renew_4;
            this.stats.perf_renew_5 = stats.perf_renew_5;
            this.stats.perf_renew_6 = stats.perf_renew_6;
            this.stats.perf_renew_more = stats.perf_renew_more;
            this.stats.perf_renew_avg = stats.perf_renew_avg;
            this.stats.amount_first = stats.amount_first;
            this.stats.amount_renew_1 = stats.amount_renew_1;
            this.stats.amount_renew_2 = stats.amount_renew_2;
            this.stats.amount_renew_3 = stats.amount_renew_3;
            this.stats.amount_renew_4 = stats.amount_renew_4;
            this.stats.amount_renew_5 = stats.amount_renew_5;
            this.stats.amount_renew_6 = stats.amount_renew_6;
            this.stats.amount_renew_more = stats.amount_renew_more;
            this.stats.amount_canceled = stats.amount_canceled;
            this.stats.amount_canceled_1w = stats.amount_canceled_1w;
            this.stats.amount_canceled_48d = stats.amount_canceled_48d;
            this.isLoadingPerformance = false;

            this.$refs.performanceSubsCancel0dChart.updateSeries([{
              type: 'column',
              name: "0 days",
              data: evolCancelGraph.cancel_0d
            }, {
              type: 'line',
              name: "Cancel Ratio",
              data: evolCancelGraph.ratio_cancel_0d
            }]);
            this.$refs.performanceSubsCancel2dChart.updateSeries([{
              type: 'column',
              name: " <= 2 days",
              data: evolCancelGraph.cancel_2d
            }, {
              type: 'line',
              name: "Cancel Ratio",
              data: evolCancelGraph.ratio_cancel_2d
            }]);
            this.$refs.performanceSubsCancel7dChart.updateSeries([{
              type: 'column',
              name: "< 7 days",
              data: evolCancelGraph.cancel_7d
            }, {
              type: 'line',
              name: "Cancel Ratio",
              data: evolCancelGraph.ratio_cancel_7d
            }]);
            this.$refs.performanceSubsCancel14dChart.updateSeries([{
              type: 'column',
              name: "< 14 days",
              data: evolCancelGraph.cancel_14d
            }, {
              type: 'line',
              name: "Cancel Ratio",
              data: evolCancelGraph.ratio_cancel_14d
            }]);
            this.$refs.performanceSubsCancel30dChart.updateSeries([{
              type: 'column',
              name: "< 30 days",
              data: evolCancelGraph.cancel_30d
            }, {
              type: 'line',
              name: "Cancel Ratio",
              data: evolCancelGraph.ratio_cancel_30d
            }]);
            this.$refs.performanceSubsCancel30plusChart.updateSeries([{
              type: 'column',
              name: ">= 30 days",
              data: evolCancelGraph.cancel_30plus
            }, {
              type: 'line',
              name: "Cancel Ratio",
              data: evolCancelGraph.ratio_cancel_30plus
            }])

            this.$refs.performanceSubsNoRenewChart.updateSeries([{
              type: 'column',
              name: "Subscriptions Not Renewed",
              data: evolCancelGraph.without_renews
            }, {
              type: 'line',
              name: "Ratio",
              data: evolCancelGraph.ratio_without_renews
            }]);


            this.$refs.performanceSubs1RenewChart.updateSeries([{
              type: 'column',
              name: "Subscriptions Started",
              data: evolCancelGraph.first
            }, {
              type: 'line',
              name: "Renew Ratio",
              data: evolCancelGraph.ratio_1_renew
            }]);

            this.$refs.performanceSubsResubChart.updateSeries([{
              type: 'column',
              name: "Subscriptions Canceled",
              data: evolCancelGraph.canceled
            }, {
              type: 'line',
              name: "Resub Ratio",
              data: evolCancelGraph.ratio_1_resub
            }]);

            this.$refs.performanceSubsAgeChart.updateSeries([{
              name: "First",
              group: 'success',
              data: ageGraph.first
            },{
              name: "Renew 1",
              group: 'success',
              data: ageGraph.renew_1
            },{
              name: "Renew 2",
              group: 'success',
              data: ageGraph.renew_2
            },{
              name: "Renew 3",
              group: 'success',
              data: ageGraph.renew_3
            },{
              name: "Renew 4",
              group: 'success',
              data: ageGraph.renew_4
            },{
              name: "Renew 5",
              group: 'success',
              data: ageGraph.renew_5
            },{
              name: "Renew 6",
              group: 'success',
              data: ageGraph.renew_6
            },{
              name: "Renew +",
              group: 'success',
              data: ageGraph.renew_more
            },{
              name: "Canceled",
              group: 'cancel',
              data: ageGraph.renew_canceled
            },{
              name: "Canceled 1W",
              group: 'cancel',
              data: ageGraph.renew_canceled_1w
            },{
              name: "Canceled 2D",
              group: 'cancel',
              data: ageGraph.renew_canceled_48h
            }]);

          })
          .catch(error => {
            window.console.error(error);
            this.isLoadingPerformance = false;
          });
    },

    getMediaThumb() {
      if (this.subscriptions.length > 0)
        this.subscriptions.forEach(trans => {
          if (trans.photo && trans.photo.length > 0)
            Storage.getUserMedia(trans.userId, trans.photo, 'subscription-user-'+trans.id);
        });
    },

    getMediaThumbExtended() {
      if (this.subscriptionsExtended.length > 0)
        this.subscriptionsExtended.forEach(trans => {
          if (trans.photo && trans.photo.length > 0)
            Storage.getUserMedia(trans.userId, trans.photo, 'subscription-extended-user-'+trans.id);
        });
    },

    loadSubscriptions() {
      this.isLoading = true;
      const params = this.getRequestParams();
      this.subscriptionsSearch = 'filters';
      FinanceDataService
          .getSubscriptions(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.subscriptions = items;
            this.count = totalItems;
            this.isLoading = false;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoading = false;
          });
    },

    loadDetails(subscriptionId) {
      this.$toast.warning("loadDetails not implemented: " + subscriptionId);
    },

    searchUser(userId) {
      this.filters.searchType.selected = 'userId';
      this.filters.searchData = userId;
      this.processSearch(true);
    },

    searchOrder(orderId) {
      this.filters.searchType.selected = 'orderId';
      this.filters.searchData = orderId;
      this.processSearch(true);
    },

    processPerformanceFilters() {
      this.loadPerformance();
    },

    processExtendedFilters() {
      this.pageExtended = 1;
      this.countExtended = 0;
      this.loadExtendedStats(false);
    },

    processFilters() {
      this.loadSubscriptions();
      this.loadStats();
    },

    processSearch(resetPage) {
      if (isEmpty(this.filters.searchType)) {
        this.$toast.error(this.$t("finance.error_searchType"));
        return;
      }

      if (isEmpty(this.filters.searchData)) {
        this.$toast.error(this.$t("finance.error_searchData"));
        return;
      }

      this.subscriptionsSearch = 'search';
      if (resetPage) {
        this.page = 1;
      }

      this.isLoading = true;
      const params = {
        type: this.filters.searchType.selected,
        data: this.filters.searchData,
        page: this.page - 1,
        size: this.pageSizes.selected,
      };

      FinanceDataService
          .searchSubscriptions(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.subscriptions = items;
            this.count = totalItems;
            this.isLoading = false;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoading = false;
          });
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },
  mounted() {
    this.getFilters();
    this.processFilters();
    this.processExtendedFilters();
    this.processPerformanceFilters();
    this.loadSubscriptionsHistory();
  },
  computed: {
    ...authComputed
  },
  watch: {
    "filters.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        } else {
          organic.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      } else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
    },
    "filtersPerformance.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersPerformance.ads.selected = 'all';
        this.filtersPerformance.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersPerformance.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        } else {
          organic.ads.forEach(ad => {
            this.filtersPerformance.ads.options.push(ad);
          });
        }
      } else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersPerformance.ads.selected = 'all';
        this.filtersPerformance.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersPerformance.ads.options.push(ad);
          });
        }
      }
    },

    "filtersPerformance.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData1(this.filtersPerformance, newVal);
    },
    "filters.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData1(this.filters, newVal);
    },

    "filtersPerformance.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData2(this.filtersPerformance, newVal);
    },
    "filters.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData2(this.filters, newVal);
    },

    "filtersPerformance.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData3(this.filtersPerformance, newVal);
    },
    "filters.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData3(this.filters, newVal);
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingPerformance: false,
      isLoadingExtended: false,
      title: this.$t("menuitems.finance.subscriptions"),
      subscriptionsSearch: 'filters',
      subscriptions: [],
      subscriptionsExtended: [],
      page: 1,
      pageExtended: 1,
      count: 0,
      countExtended: 0,
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '50'
      },
      pageExtendedSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      stats: {
        active: '-',
        active_perc: '-',
        canceled: '-',
        canceled_perc: '-',
        suspended: '-',
        suspended_perc: '-',
        ended: '-',
        ended_perc: '-',
        total_subs: '-',
        total_active: '-',
        total_suspended: '-',
        total_canceled: '-',
        perf_first: '-',
        perf_canceled_48d: '-',
        perf_canceled: '-',
        perf_canceled_1w: '-',
        perf_renew_1: '-',
        perf_renew_2: '-',
        perf_renew_3: '-',
        perf_renew_4: '-',
        perf_renew_5: '-',
        perf_renew_6: '-',
        perf_renew_more: '-',
        perf_renew_avg: '-',
        amount_first: '-',
        amount_renew_1: '-',
        amount_renew_2: '-',
        amount_renew_3: '-',
        amount_renew_4: '-',
        amount_renew_5: '-',
        amount_renew_6: '-',
        amount_renew_more: '-',
        amount_canceled: '-',
        amount_canceled_48d: '-',
        amount_canceled_1w: '-',
        extended: 0,
        extendedRenew: 0,
        extendedCanceled: 0,
        extendedExcluded: 0,
        extendedDisplayed: 0,
        extendedDeclined: 0,
        extendedAccepted: 0,
      },
      productsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'subscriptions-products',
            type: 'donut',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'products-subscriptions'
                },
                svg: {
                  filename: 'products-subscriptions'
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'left'
          },
        }
      },
      /*methodsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'subscriptions-methods',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'left'
          },
        }
      },*/
      processorsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'subscriptions-processors',
            type: 'donut',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'processors-subscriptions'
                },
                svg: {
                  filename: 'processors-subscriptions'
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'left'
          },
        }
      },
      subscriptionsTotalHistoryGraph: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            type: 'line',
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'subscriptions-count-history'
                },
                svg: {
                  filename: 'subscriptions-count-history'
                }
              }
            }
          },
          title: {
            text: "Subscriptions Count",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          colors: ["#556ee6", "#222222"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false
              },
              title: {
                text: "Count"
              },
            },
          ],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      subscriptionsHistoryGraph: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            type: 'line',
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'subscriptions-details-history'
                },
                svg: {
                  filename: 'subscriptions-details-history'
                }
              }
            }
          },
          title: {
            text: "Subscriptions Details",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          colors: ["#00E396", "#f46a6a", "#F1B44C"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false
              },
              title: {
                text: "Count"
              },
            },
          ],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      performanceSub1RenewGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            id: "performance-subs-renews",
            group: "performance-subs",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-1-renew-subscriptions'
                },
                svg: {
                  filename: 'history-1-renew-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions With 1 renew min",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Subscriptions Count"
            }
          }, {
            seriesName: 'Renew Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Renew Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#00E396", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubResubGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            id: "performance-subs-resubs",
            group: "performance-subs",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-resub-subscriptions'
                },
                svg: {
                  filename: 'history-resub-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Canceled With New Subscription",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Canceled Count"
            }
          }, {
            seriesName: 'Resub Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Resub Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#F1B44C", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubWithoutRenewGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            id: "performance-subs-no-renews",
            group: "performance-subs",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-no-renew-subscriptions'
                },
                svg: {
                  filename: 'history-no-renew-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Without Any Renew",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Subscriptions Count"
            }
          }, {
            seriesName: 'Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#f14ce9", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      performanceSubCancel0dGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-cancel-0d-subscriptions'
                },
                svg: {
                  filename: 'history-cancel-0d-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Cancelation Delay = 0 Days",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Cancels Count"
            }
          }, {
              seriesName: 'Cancel Ratio',
              opposite: true,
            min: 0,
            max: 100,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#000000'
              },
              labels: {
                style: {
                  colors: '#000000',
                }
              },
              title: {
                text: "Cancel Ratio",
                style: {
                  color: '#000000',
                }
              },
            },
          ],
          colors: ["#efa2c5", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubCancel2dGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-cancel-2d-subscriptions'
                },
                svg: {
                  filename: 'history-cancel-2d-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Cancelation Delay <= 2 Days",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Cancel Count"
            }
          }, {
            seriesName: 'Cancel Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Cancel Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#efa2c5", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubCancel7dGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-cancel-7d-subscriptions'
                },
                svg: {
                  filename: 'history-cancel-7d-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Cancelation Delay < 7 Days",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Cancel Count"
            }
          }, {
            seriesName: 'Cancel Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Cancel Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#efa2c5", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubCancel14dGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-cancel-14d-subscriptions'
                },
                svg: {
                  filename: 'history-cancel-14d-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Cancelation Delay < 14 Days",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Cancel Count"
            }
          }, {
            seriesName: 'Cancel Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Cancel Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#efa2c5", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubCancel30dGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-cancel-30d-subscriptions'
                },
                svg: {
                  filename: 'history-cancel-30d-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Cancelation Delay < 30 Days",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          stroke: {
            curve: 'smooth',
            width: 1,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Cancel Count"
            }
          }, {
            seriesName: 'Cancel Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Cancel Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#efa2c5", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceSubCancel30plusGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true
              },
              export: {
                png: {
                  filename: 'history-cancel-30plus-subscriptions'
                },
                svg: {
                  filename: 'history-cancel-30plus-subscriptions'
                }
              }
            },
          },
          title: {
            text: "Subscriptions Cancelation Delay >= 30 Days",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Cancel Count"
            },
          }, {
            seriesName: 'Cancel Ratio',
            opposite: true,
            min: 0,
            max: 100,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                colors: '#000000',
              }
            },
            title: {
              text: "Cancel Ratio",
              style: {
                color: '#000000',
              }
            },
          },
          ],
          colors: ["#efa2c5", "#000000"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      performanceAgeGraph: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            type: 'bar',
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-age-subscriptions'
                },
                svg: {
                  filename: 'performance-age-subscriptions'
                }
              }
            }
          },
          title: {
            text: "Age Performance",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          dataLabels: {
            enabled: true
          },
          colors: ["#00E396", "#032c62", "#043c85", "#074fad", "#095bc5", "#2980f1", "#38c5f8", "#a078e5", "#da326b", "#F1B44C", "#e3896e"],
          xaxis: {
            categories: ["18-24", "25-29", "30-34", "35-39", "40-44", "45-49", "50-54", "55-59", "60-64", "65-69", "70-100"],
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              decimalsInFloat: 0,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#666666',
                }
              },
              tooltip: {
                enabled: true
              }
            },
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          legend: {
            position: 'bottom',
          }
        },
      },
      evolGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'history-subscriptions'
                },
                svg: {
                  filename: 'history-subscriptions'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              borderRadius: 10,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Nb"
            }
          }],
          colors: ["#34c38f", "#f46a6a", "#f1b44c", "#efa2c5"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      extendedGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'history-subscriptions-extended'
                },
                svg: {
                  filename: 'history-subscriptions-extended'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              borderRadius: 10,
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Nb"
            }
          }],
          colors: ["#666666", "#f1b44c"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      extendedDisplayedGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'history-subscriptions-displayed-extended'
                },
                svg: {
                  filename: 'history-subscriptions-displayed-extended'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              borderRadius: 10,
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Nb"
            }
          }],
          colors: ["#666666", "#f46a6a"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      extendedGraphStats: {
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'history-subscriptions-stats-extended'
                },
                svg: {
                  filename: 'history-subscriptions-stats-extended'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              borderRadius: 10,
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Nb"
            }
          }],
          colors: ["#556ee6", "#f46a6a"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },


      filtersSubscriptionsHistoryDates: {
        selected: '1M',
        options: [
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      },
      filtersSubscriptionsHistoryCountries: {
        selected: 'all',
        options: [
          {value: 'all', text: 'All Countries'},
          {value: '', text: '----------------'},
          {value: 'FR', text: 'FR - France'},
          {value: 'BE', text: 'BE - Belgium'},
          {value: 'CH', text: 'CH - Switzerland'},
          {value: 'CA', text: 'CA - Canada'},
          {value: '', text: '----------------'},
          {value: 'others', text: 'Others'},
        ]
      },
      filtersSubscriptionsExtended: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'last30Day',
          options: [
            {value: 'week', text: this.$t("dates.week")},
            {value: 'curMonth', text: this.$t("dates.curMonth")},
            {value: 'last30Day', text: this.$t("dates.last30Day")},
            {value: 'lastMonth', text: this.$t("dates.lastMonth")},
            {value: 'last3Month', text: this.$t("dates.last3Month")},
            {value: 'curYear', text: this.$t("dates.curYear")},
            {value: 'always', text: this.$t("dates.always")},
            {value: 'custom', text: this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
      },
      filtersPerformance: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'last30Day',
          options: [
            {value: 'today', text: this.$t("dates.today")},
            {value: 'yesterday', text: this.$t("dates.yesterday")},
            {value: 'week', text: this.$t("dates.week")},
            {value: 'curMonth', text: this.$t("dates.curMonth")},
            {value: 'last30Day', text: this.$t("dates.last30Day")},
            {value: 'lastMonth', text: this.$t("dates.lastMonth")},
            {value: 'last3Month', text: this.$t("dates.last3Month")},
            {value: 'curYear', text: this.$t("dates.curYear")},
            {value: 'always', text: this.$t("dates.always")},
            {value: 'custom', text: this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        promo: {
          selected: 'all',
          options: [
            {value: 'all', text: "All products"},
            {value: 1, text: "Only Promo"},
            {value: 0, text: "No Promo"}
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
      },
      filters: {
        searchType: {
          selected: 'userId',
          options: [
            {value:'userId', text:this.$t("userId")},
            {value:'orderId', text:this.$t("orderId")},
            {value:'email', text:this.$t("email")}
          ]
        },
        searchData: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        promo: {
          selected: 'all',
          options: [
            {value: 'all', text: "All products"},
            {value: 1, text: "Only Promo"},
            {value: 0, text: "No Promo"}
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        status: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.status_all")},
            {value: 'A', text: this.$t("finance.status_sub_A")},
            {value: 'S', text: this.$t("finance.status_sub_S")},
            {value: 'C', text: this.$t("finance.status_sub_C")},
            {value: 'E', text: this.$t("finance.status_sub_E")},
          ]
        }
      },
      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Global Analytics -->
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">Global Analytics</h3>

          <div class="row">
            <div class="col-12 col-lg-3">

              <div class="card bg-info mini-stats-wid">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">Subscriptions Count</p>
                      <h4 class="mb-0 text-white">{{ stats.total_subs }}</h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-white text-info">
                        <i class="bx bx-stats font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12 col-lg-3">
              <div class="card bg-success mini-stats-wid">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">Active</p>
                      <h4 class="mb-0 text-white">{{ stats.total_active }}</h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-white text-success">
                        <i class="bx bx-infinite font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12 col-lg-3">
              <div class="card bg-danger mini-stats-wid">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">Suspended</p>
                      <h4 class="mb-0 text-white">{{ stats.total_suspended }}</h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-white text-danger">
                      <i class="bx bx-error font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-3">
              <div class="card bg-warning mini-stats-wid">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">Canceled</p>
                      <h4 class="mb-0 text-white">{{ stats.total_canceled }}</h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-white text-warning">
                      <i class="bx bx-stop-circle font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="row" id="subscriptionsHistoryCountChart">
            <hr>
            <div class="col-sm-auto d-flex">
              <b-form-radio-group
                  v-model="filtersSubscriptionsHistoryDates.selected"
                  :options="filtersSubscriptionsHistoryDates.options"
                  button-variant="outline-secondary"
                  size="sm"
                  buttons
                  class="mt-1 mb-2"
                  @change="handleDateSubscriptionsHistoryChange"
              ></b-form-radio-group>
            </div>

            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="performanceCountriesFilter"
                  v-model="filtersSubscriptionsHistoryCountries.selected"
                  class="form-select me-lg-1"
                  :options="filtersSubscriptionsHistoryCountries.options"
                  @change="handleDateSubscriptionsHistoryChange">
              </b-form-select>
            </div>

          </div>
          <div class="row">
            <div class="col-12 col-lg-7">
              <apexchart
                  ref="subscriptionsHistoryChart"
                  type="line"
                  height="350"
                  :series="subscriptionsHistoryGraph.series"
                  :options="subscriptionsHistoryGraph.chartOptions"
              ></apexchart>
            </div>
            <div class="col-12 col-lg-5">
              <apexchart
                  ref="subscriptionsTotalHistoryChart"
                  type="line"
                  height="350"
                  :series="subscriptionsTotalHistoryGraph.series"
                  :options="subscriptionsTotalHistoryGraph.chartOptions"
              ></apexchart>
            </div>

          </div>

        </div>
      </div>

      <!-- Performance Renewing -->

      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">Performance Renewing</h3>

          <!-- Filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="performanceRenewingFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="performanceDatesFilter"
                  @change="handleDatePerformanceChange"
                  v-model="filtersPerformance.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersPerformance.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersPerformance.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceCountriesFilter"
                  v-model="filtersPerformance.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.countries.options">
              </b-form-select>
            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceGenderFilter"
                  v-model="filtersPerformance.genders.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Subscriptions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceSubFilter"
                  v-model="filtersPerformance.subscriptions.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Promo -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePromoFilter"
                  v-model="filtersPerformance.promo.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.promo.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceMethodFilter"
                  v-model="filtersPerformance.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceProcessorFilter"
                  v-model="filtersPerformance.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceOrganicFilter"
                  v-model="filtersPerformance.organic.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceAdsFilter"
                  v-model="filtersPerformance.ads.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
              <b-form-select
                  id="performanceAdsData1Filter"
                  v-model="filtersPerformance.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
              <b-form-select
                  id="performanceAdsData2Filter"
                  v-model="filtersPerformance.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
              <b-form-select
                  id="performanceAdsData3Filter"
                  v-model="filtersPerformance.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processPerformanceFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingPerformance"
                :loading="isLoadingPerformance"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <!-- results -->
          <div class="row">
            <div class="col-12">

              <div class="table-responsive">
                <table
                    id="subscriptions-list"
                    class="table project-list-table table-nowrap table-centered align-middle"
                >
                  <thead class="table-light">
                  <tr>
                    <th scope="col">Started</th>
                    <th scope="col">AVG Renew</th>
                    <th scope="col">Canceled</th>
                    <th scope="col">1 Renew</th>
                    <th scope="col">2 Renews</th>
                    <th scope="col">3 Renews</th>
                    <th scope="col">4 Renews</th>
                    <th scope="col">5 Renews</th>
                    <th scope="col">6 Renews</th>
                    <th scope="col">+ Renews</th>
                    <th scope="col">2 Days Cancel</th>
                    <th scope="col">1 Week Cancel</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><span class="d-inline-block p-2 text-bg-success text-white">{{ stats.perf_first}}</span></td>
                      <td><span class="d-inline-block p-2 text-bg-info text-white">{{ stats.perf_renew_avg}}</span></td>
                      <td><span class="d-inline-block p-2 text-bg-danger text-white">{{ stats.perf_canceled}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_1}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_2}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_3}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_4}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_5}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_6}}</span></td>
                      <td><span class="text-muted">{{ stats.perf_renew_more}}</span></td>
                      <td><span class="d-inline-block p-2 text-danger">{{ stats.perf_canceled_48d}}</span></td>
                      <td><span class="d-inline-block p-2 text-bg-warning text-white">{{ stats.perf_canceled_1w}}</span></td>
                    </tr>
                    <tr>
                      <td><span class="d-inline-block p-2 text-bg-success text-white">{{ stats.amount_first / 100}}€</span></td>
                      <td><span class="text-muted">-</span></td>
                      <td><span class="d-inline-block p-2 text-bg-danger text-white">{{ stats.amount_canceled / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_1 / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_2 / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_3 / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_4 / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_5 / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_6 / 100}}€</span></td>
                      <td><span class="text-muted">{{ stats.amount_renew_more / 100}}€</span></td>
                      <td><span class="d-inline-block p-2 text-danger">{{ stats.amount_canceled_48d / 100}}€</span></td>
                      <td><span class="d-inline-block p-2 text-bg-warning text-white">{{ stats.amount_canceled_1w / 100}}€</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <apexchart
                  ref="performanceSubsAgeChart"

                  type="bar"
                  height="350"
                  :series="performanceAgeGraph.series"
                  :options="performanceAgeGraph.chartOptions"
              ></apexchart>

            </div>
          </div>

          <!-- Renews graph -->
          <div class="row">

            <div class="col-12 bg-light card">
              <div class="card-title mt-2">Renews Stats</div>
              <div class="card-title-desc">Rate of subscriptions with 1 renewal min.</div>
            </div>

            <!-- 1-renew-graph -->
            <div class="col-12">
              <apexchart
                  ref="performanceSubs1RenewChart"
                  type="line"
                  height="300"
                  :series="performanceSub1RenewGraph.series"
                  :options="performanceSub1RenewGraph.chartOptions"
              ></apexchart>
            </div>


          </div>

          <!-- No Renew graph -->
          <div class="row">

            <div class="col-12 bg-light card">
              <div class="card-title mt-2">No Renew Stats</div>
              <div class="card-title-desc">Number of not canceled Subscriptions witout any renew.</div>
            </div>

            <!-- no-renew-graph -->
            <div class="col-12">
              <apexchart
                  ref="performanceSubsNoRenewChart"
                  type="line"
                  height="300"
                  :series="performanceSubWithoutRenewGraph.series"
                  :options="performanceSubWithoutRenewGraph.chartOptions"
              ></apexchart>
            </div>


          </div>

          <!-- ReSub graph -->
          <div class="row">

            <div class="col-12 bg-light card">
              <div class="card-title mt-2">Re-Subscriptions Stats</div>
              <div class="card-title-desc">Rate of canceled subscriptions who resubscribe after.</div>
            </div>

            <!-- 1-resub-graph -->
            <div class="col-12">
              <apexchart
                  ref="performanceSubsResubChart"
                  type="line"
                  height="300"
                  :series="performanceSubResubGraph.series"
                  :options="performanceSubResubGraph.chartOptions"
              ></apexchart>
            </div>

          </div>


          <!-- Cancels graph -->
          <div class="row">

            <div class="col-12 bg-light card">
              <div class="card-title mt-2">Cancelations Stats</div>
              <div class="card-title-desc">Number and rate of cancelations by delay before cancelation. Cumulative data</div>
            </div>

            <!-- 0d -->
            <div class="col-lg-6 col-12">
              <apexchart
                  ref="performanceSubsCancel0dChart"
                  type="line"
                  height="300"
                  :series="performanceSubCancel0dGraph.series"
                  :options="performanceSubCancel0dGraph.chartOptions"
              ></apexchart>
            </div>
            <!-- 2d -->
            <div class="col-lg-6 col-12">
              <apexchart
                  ref="performanceSubsCancel2dChart"
                  type="line"
                  height="300"
                  :series="performanceSubCancel2dGraph.series"
                  :options="performanceSubCancel2dGraph.chartOptions"
              ></apexchart>
            </div>

          </div>
          <div class="row">
            <!-- 7d -->
            <div class="col-lg-6 col-12">
              <apexchart
                  ref="performanceSubsCancel7dChart"
                  type="line"
                  height="300"
                  :series="performanceSubCancel7dGraph.series"
                  :options="performanceSubCancel7dGraph.chartOptions"
              ></apexchart>
            </div>
            <!-- 14d -->
            <div class="col-lg-6 col-12">
              <apexchart
                  ref="performanceSubsCancel14dChart"
                  type="line"
                  height="300"
                  :series="performanceSubCancel14dGraph.series"
                  :options="performanceSubCancel14dGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
          <div class="row">
            <!-- 30d -->
            <div class="col-lg-6 col-12">
              <apexchart
                  ref="performanceSubsCancel30dChart"
                  type="line"
                  height="300"
                  :series="performanceSubCancel30dGraph.series"
                  :options="performanceSubCancel30dGraph.chartOptions"
              ></apexchart>
            </div>

            <!-- 30+ -->
            <div class="col-lg-6 col-12">
              <apexchart
                  ref="performanceSubsCancel30plusChart"
                  type="line"
                  height="300"
                  :series="performanceSubCancel30plusGraph.series"
                  :options="performanceSubCancel30plusGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>
      </div>

      <!-- Extended Analytics -->

      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">Extended Analytics</h3>
          <!-- filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="subscriptionsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="subscriptionsExtendedDatesFilter"
                  @change="handleDateExtendedChange"
                  v-model="filtersSubscriptionsExtended.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersSubscriptionsExtended.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersSubscriptionsExtended.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersSubscriptionsExtended.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsExtendedCountriesFilter"
                  v-model="filtersSubscriptionsExtended.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersSubscriptionsExtended.countries.options">
              </b-form-select>
            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsExtendedGenderFilter"
                  v-model="filtersSubscriptionsExtended.genders.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersSubscriptionsExtended.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processExtendedFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingExtended"
                :loading="isLoadingExtended"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <!-- Stats -->
          <div class="row">

            <!-- Extended -->
            <div class="col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Sub. Extended</p>
                      <h4 class="mb-0">{{ stats.extended }} <small class="font-size-12">/ {{ stats.extendedExcluded }}</small></h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-warning text-dark">
                    <i class="bx bx-infinite font-size-24"></i>
                  </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Has renew -->
            <div class="col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Extended with Renews</p>
                      <h4 class="mb-0">{{ stats.extendedRenew }}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-info text-white">
                    <i class="bx bx-error font-size-24"></i>
                  </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Canceled -->
            <div class="col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Extended now Canceled</p>
                      <h4 class="mb-0">{{ stats.extendedCanceled }}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-danger text-white">
                    <i class="bx bx-stop-circle font-size-24"></i>
                  </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Displayed -->
            <div class="col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Popup Displayed</p>
                      <h4 class="mb-0">{{ stats.extendedDisplayed }} <small class="font-size-11"><b>{{ stats.extendedDeclined}}</b> declined</small></h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-light text-dark">
                    <i class="bx bx-stats font-size-24"></i>
                  </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- charts -->
          <div class="row mb-3">

            <div class="col-12 col-lg-6">
              <apexchart
                  ref="extendedGraphChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="300"
                  :series="extendedGraph.series"
                  :options="extendedGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-12 col-lg-6">
              <apexchart
                  ref="extendedStatsGraphChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="300"
                  :series="extendedGraphStats.series"
                  :options="extendedGraphStats.chartOptions"
              ></apexchart>
            </div>

            <div class="col-12">
              <apexchart
                ref="extendedPurposeGraphChart"
                class="apex-charts"
                type="bar"
                dir="ltr"
                height="300"
                :series="extendedDisplayedGraph.series"
                :options="extendedDisplayedGraph.chartOptions"
              ></apexchart>

            </div>

          </div>

          <!-- Listing -->
          <div class="row mb-3">

            <!-- Display settings -->
            <div class="col-lg-auto col-12">
              <b-select class="form-select d-inline w-auto m-1" v-model="pageExtendedSizes.selected" @change="handleDisplayExtendedChange">
                <option v-for="size in pageExtendedSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
              </b-select>

              {{ countExtended }} {{ $t('resultsCount') }}
            </div>
            <!-- Pagination -->
            <div class="col-lg-auto col-12">
              <div class="m-1 pagination-rounded">
                <b-pagination
                    v-model="pageExtended"
                    :total-rows="countExtended"
                    :per-page="pageExtendedSizes.selected"
                    first-number
                    last-number
                    @change="handlePageExtendedChange"
                    aria-controls="subscriptions-extended-list"
                ></b-pagination>
              </div>
            </div>

            <!-- results -->
            <div v-if="!isLoadingExtended && subscriptionsExtended.length > 0">
              <div class="table-responsive">
                <table
                    id="subscriptions-extended-list"
                    class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                >
                  <thead>
                  <tr>
                    <th scope="col">{{ $t('finance.createdAt') }}</th>
                    <th scope="col">Extended At</th>
                    <th scope="col">{{ $t('finance.status') }}</th>
                    <th scope="col">{{ $t('finance.orderid') }}</th>
                    <th scope="col">{{ $t('finance.user') }}</th>
                    <th scope="col">{{ $t('action') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="subscription in subscriptionsExtended" :key="subscription.id">
                    <td>
                      <p class="text-muted font-size-12">
                        <i class="bx bx-calendar-event"></i><span class="text-info">{{ formatDateString(subscription.startedAt, 'DD MMM YYYY HH:mm') }}</span>
                        <br><i class="bx bx-stop-circle"></i>{{ formatDateString(subscription.canceledAt, 'DD MMM YYYY HH:mm') }}
                        <br><i class="bx bx-trash"></i><span class="text-pink">{{ formatDateString(subscription.endedAt, 'DD MMM YYYY HH:mm') }}</span>
                      </p>
                    </td>
                    <td>
                      <span class="text-primary fw-bold">{{ formatDateString(subscription.extendedAt, 'DD MMM YYYY HH:mm') }}</span>
                    </td>
                    <td>
                      <span
                          class="badge"
                          :class="{
                            'bg-success text-light': `${subscription.status}` === 'A',
                            'bg-danger text-light': `${subscription.status}` === 'S',
                            'bg-warning text-light': `${subscription.status}` === 'C',
                            'bg-pink text-text': `${subscription.status}` === 'E',
                          }"
                      >{{ $t(`finance.status_sub_${subscription.status}`) }}</span
                      >
                    </td>
                    <td>
                      <p class="text-muted font-size-12">
                        <strong>{{ subscription.orderId }}</strong>
                        <br>{{ $t(`finance.${subscription.productId}`) }}
                      </p>
                    </td>
                    <td>
                      <div class="media">
                        <div class="avatar-xs">
                          <img
                              :id="`subscription-extended-user-${subscription.id}`"
                              :src="require('@/assets/images/users/default-user.png')"
                              class="d-flex rounded-circle avatar-xs" />
                        </div>
                        <div class="media-body ms-1">
                          <h5 class="font-size-14 mb-0">
                            <span
                                :class="{
                                'text-primary': subscription.sex === 1,
                                'text-danger': subscription.sex === 2,
                                'text-dark': subscription.sex === 0,
                              }"
                            >
                            {{ subscription.name || '-' }}
                          </span> {{ getAge(subscription.birth) }}</h5>
                          <small class="text-muted">#{{ subscription.userId }}</small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <b-dropdown
                          class="card-drop"
                          variant="white"
                          menu-class="dropdown-menu-end"
                          right
                          toggle-class="p-0"
                      >
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item
                            href="javascript: void(0);"
                            @click="showUser(subscription.userId)"
                        >{{ $t("show_user") }}</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Result Empty -->
            <div v-if="!isLoadingExtended && subscriptionsExtended.length === 0">
              <div class="card-body">
                <h4 class="card-title">Empty Result</h4>
                <p>No subscriptions Extended were found for these filters or search. Try again.</p>
              </div>
            </div>

            <!-- Display settings -->
            <div class="col-lg-auto col-12">
              <b-select class="form-select d-inline w-auto m-1" v-model="pageExtendedSizes.selected" @change="handleDisplayExtendedChange">
                <option v-for="size in pageExtendedSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
              </b-select>
            </div>
            <!-- Pagination -->
            <div class="col-lg-auto col-12">
              <div class="m-1 pagination-rounded">
                <b-pagination
                    v-model="pageExtended"
                    :total-rows="countExtended"
                    :per-page="pageExtendedSizes.selected"
                    first-number
                    last-number
                    @change="handlePageExtendedChange"
                    aria-controls="subscriptions-extended-list"
                ></b-pagination>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Granular Analytics -->

      <div class="card">
        <div class="card-body">
          <h3 class="mb-4">Granular Analytics</h3>
          <!-- Search -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="subscriptionsSearchForm" @submit.stop.prevent>
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsSearchTypeFilter"
                  v-model="filters.searchType.selected"
                  class="form-select me-lg-1"
                  :options="filters.searchType.options">
              </b-form-select>
            </div>
            <div class="col-sm-auto">
              <b-form-input
                  id="subscriptionsSearchData"
                  class="me-lg-1"
                  v-model="filters.searchData"
                  placeholder="Search…">
              </b-form-input>
            </div>
            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processSearch(true)">{{ $t("searchBtn") }}</b-button>
            </div>
          </b-form>
          <hr />
          <!-- filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="subscriptionsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="subscriptionsDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsCountriesFilter"
                  v-model="filters.countries.selected"
                  class="form-select me-lg-1"
                  :options="filters.countries.options">
              </b-form-select>
            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsGenderFilter"
                  v-model="filters.genders.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Subscriptions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsSubFilter"
                  v-model="filters.subscriptions.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Promo -->
            <div class="col-sm-auto">
              <b-form-select
                  id="susbcriptionsPromoFilter"
                  v-model="filters.promo.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.promo.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsMethodFilter"
                  v-model="filters.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsProcessorFilter"
                  v-model="filters.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Status -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsStatusFilter"
                  v-model="filters.status.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="st in filters.status.options" :key="st.value" :value="st.value">{{ st.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsOrganicFilter"
                  v-model="filters.organic.selected"
                  class="form-select me-lg-1"
                  :options="filters.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="subscriptionsAdsFilter"
                  v-model="filters.ads.selected"
                  class="form-select me-lg-1"
                  :options="filters.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
              <b-form-select
                  id="subscriptionsAdsData1Filter"
                  v-model="filters.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
              <b-form-select
                  id="subscriptionsAdsData2Filter"
                  v-model="filters.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
              <b-form-select
                  id="subscriptionsAdsData3Filter"
                  v-model="filters.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Stats Plain -->
      <div class="row" v-if="subscriptionsSearch === 'filters'">
        <!-- Active -->
        <div class="col-lg-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark fw-medium mb-2">{{ $t("finance.status_sub_A") }}</p>
                  <h4 class="mb-0">{{ stats.active }} <span class="fs-5 text-muted">{{ stats.active_perc }}%</span></h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-success text-light">
                    <i class="bx bx-infinite font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Suspended -->
        <div class="col-lg-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark fw-medium mb-2">{{ $t("finance.status_sub_S") }}</p>
                  <h4 class="mb-0">{{ stats.suspended }} <span class="fs-5 text-muted">{{ stats.suspended_perc }}%</span></h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-danger">
                    <i class="bx bx-error font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Canceled -->
        <div class="col-lg-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark fw-medium mb-2">{{ $t("finance.status_sub_C") }}</p>
                  <h4 class="mb-0">{{ stats.canceled }} <span class="fs-5 text-muted">{{ stats.canceled_perc }}%</span></h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-canceled">
                    <i class="bx bx-stop-circle font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Ended -->
        <div class="col-lg-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-muted fw-medium mb-2">{{ $t("finance.status_sub_E") }}</p>
                  <h4 class="mb-0">{{ stats.ended }} <span class="fs-5 text-muted">{{ stats.ended_perc }}%</span></h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-ended">
                    <i class="bx bx-minus-circle font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts -->
      <div class="row" v-if="subscriptionsSearch === 'filters'">
        <!-- graph Products -->
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-body" id="cardChartProducts">
              <h5 class="card-title">Products</h5>
              <apexchart
                  ref="subscriptionsProductsChart"
                  height="200"
                  type="donut"
                  dir="ltr"
                  :series="productsGraph.series"
                  :options="productsGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <!-- graph Methods -->
        <!--
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-body" id="cardChartMethods">
              <h5 class="card-title">Methods</h5>
              <apexchart
                  ref="subscriptionsMethodsChart"
                  height="200"
                  type="donut"
                  dir="ltr"
                  :series="methodsGraph.series"
                  :options="methodsGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        -->
        <!-- graph Processors -->
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-body" id="cardChartProcessors">
              <h5 class="card-title">Processors</h5>
              <apexchart
                  ref="subscriptionsProcessorsChart"
                  height="200"
                  type="donut"
                  dir="ltr"
                  :series="processorsGraph.series"
                  :options="processorsGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Evol -->
      <div class="row" v-if="subscriptionsSearch === 'filters'">
        <div class="col-12">
          <div class="card">
            <div class="card-body" id="cardChartEvolSub">
              <h5 class="card-title">Success Evol.</h5>
              <p>Current Status of each subscription started this day</p>
              <apexchart
                  ref="subscriptionsEvolChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="300"
                  :series="evolGraph.series"
                  :options="evolGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>

          {{ count }} {{ $t('resultsCount') }}
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="subscriptions-list"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- Result list -->
      <div class="row bg-white" v-if="!isLoading && subscriptions.length > 0">
        <div class="table-responsive">
          <table
              id="subscriptions-list"
              class="table project-list-table table-nowrap table-centered table-borderless align-middle"
          >
            <thead>
            <tr>
              <th scope="col">{{ $t('finance.createdAt') }}</th>
              <th scope="col">{{ $t('finance.status') }}</th>
              <th scope="col">{{ $t('finance.orderid') }}</th>
              <th scope="col">{{ $t('finance.amount') }}</th>
              <th scope="col">{{ $t('finance.subscription') }}</th>
              <th scope="col">{{ $t('finance.method') }}</th>
              <th scope="col">{{ $t('finance.user') }}</th>
              <th scope="col">{{ $t('action') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="subscription in subscriptions" :key="subscription.id">
              <td>
                <p class="text-muted font-size-12">
                  <i class="bx bx-calendar-event"></i><span class="text-info">{{ formatDateString(subscription.startedAt, 'DD MMM YYYY HH:mm') }}</span>
                  <br><i class="bx bx-stop-circle"></i>{{ formatDateString(subscription.canceledAt, 'DD MMM YYYY HH:mm') }}
                  <br><i class="bx bx-trash"></i><span class="text-pink">{{ formatDateString(subscription.endedAt, 'DD MMM YYYY HH:mm') }}</span>
                </p>
              </td>
              <td>
                <span
                    class="badge"
                    :class="{
                      'bg-success text-light': `${subscription.status}` === 'A',
                      'bg-danger text-light': `${subscription.status}` === 'S',
                      'bg-warning text-light': `${subscription.status}` === 'C',
                      'bg-pink text-text': `${subscription.status}` === 'E',
                    }"
                >{{ $t(`finance.status_sub_${subscription.status}`) }}</span
                >
              </td>
              <td>
                <p class="text-muted font-size-12"><strong>{{ subscription.orderId }}</strong></p>
              </td>
              <td>
                <p class="font-size-14" >
                  <span
                      class="text-dark fw-bold d-inline-block me-2 text-primary"
                      >{{ subscription.amount/100 }} {{ subscription.currency }}</span>
                </p>
              </td>
              <td>
                <p class="text-muted font-size-12">{{ $t(`finance.${subscription.productId}`) }}</p>
              </td>
              <td>
                <p class="text-muted font-size-12">
                  <img :src="getPaymentMethodImg(subscription.paymentMethod, subscription.paymentProcessor)" width="24" height="24" alt=""/>
                  {{ $t(`finance.processor_${subscription.paymentProcessor}`) }}
                </p>
              </td>
              <td>
                <div class="media">
                  <div class="avatar-xs">
                    <img
                        :id="`subscription-user-${subscription.id}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-1">
                    <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': subscription.sex === 1,
                          'text-danger': subscription.sex === 2,
                          'text-dark': subscription.sex === 0,
                        }"
                      >
                        {{ subscription.name || '-' }}
                      </span> {{ getAge(subscription.birth) }}</h5>
                    <small class="text-muted">#{{ subscription.userId }}</small>
                  </div>
                </div>
              </td>
              <td>
                <b-dropdown
                    class="card-drop"
                    variant="white"
                    menu-class="dropdown-menu-end"
                    right
                    toggle-class="p-0"
                >
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-horizontal font-size-18"></i>
                  </template>
                  <b-dropdown-item
                      href="javascript: void(0);"
                      @click="loadDetails(subscription.id)"
                  >{{ $t("finance.details") }}</b-dropdown-item>
                  <b-dropdown-item
                      href="javascript: void(0);"
                      @click="searchUser(subscription.userId)"
                  >{{ $t("finance.search_user") }}</b-dropdown-item>
                  <b-dropdown-item
                      href="javascript: void(0);"
                      @click="searchOrder(subscription.orderId)"
                  >{{ $t("finance.search_order") }}</b-dropdown-item>
                  <b-dropdown-item
                      href="javascript: void(0);"
                      @click="showUser(subscription.userId)"
                  >{{ $t("show_user") }}</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && subscriptions.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No subscriptions were found for these filters or search. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="subscriptions-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>
    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>
  </Layout>
</template>

<style>

#subscriptionsHistoryCountChart .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#subscriptionsHistoryCountChart .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}

.bg-canceled {
  background-color:#f1b44c !important;
}

.bg-ended {
  background-color: #efa2c5 !important;
}

.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}

</style>
